import script from "./CaskGameSimpleList.vue?vue&type=script&setup=true&lang=js"
export * from "./CaskGameSimpleList.vue?vue&type=script&setup=true&lang=js"

import "./CaskGameSimpleList.vue?vue&type=style&index=0&id=2c970e1e&lang=sass&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2c970e1e"]])

export default __exports__
import QBtn from 'quasar/src/components/btn/QBtn.js';
import QCarousel from 'quasar/src/components/carousel/QCarousel.js';
import QCarouselSlide from 'quasar/src/components/carousel/QCarouselSlide.js';
import qInstall from "../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QBtn,QCarousel,QCarouselSlide});
